import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';

import { MobileMenuType } from './types';

export enum ActionTypes {
  SHOW_MODAL = 'NAVBAR/SHOW_AUTH_MODAL',
  HIDE_MODAL = 'NAVBAR/HIDE_AUTH_MODAL',
  OPEN_MOBILE_DRAWER = 'NAVBAR/OPEN_MOBILE_DRAWER',
  CLOSE_MOBILE_DRAWER = 'NAVBAR/CLOSE_MOBILE_DRAWER',
  SWITCH_MENU = 'NAVBAR/SWITCH_MENU',
}

export type Actions = ActionsUnion<typeof Actions>;

export const Actions = {
  showModal: (
    modalType: 'login' | 'register',
    returnUrl?: string,
    options = {},
  ) => createAction(ActionTypes.SHOW_MODAL, { modalType, returnUrl, options }),
  hideModal: () => createAction(ActionTypes.HIDE_MODAL),
  openMobileDrawer: () => createAction(ActionTypes.OPEN_MOBILE_DRAWER),
  closeMobileDrawer: () => createAction(ActionTypes.CLOSE_MOBILE_DRAWER),
  switchMenu: (menuType: MobileMenuType) =>
    createAction(ActionTypes.SWITCH_MENU, menuType),
};
